<template>
  <div class="form-outline pa-3">
    <form-legend :field="field" />
    <v-menu
      ref="menu"
      v-model="dateMenu"
      class="DateEditor"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      z-index="999"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          dense
          :value="fieldValue ? formatIsoDateStringAsLocaleDate(fieldValue, selectedLang) : ''"
          readonly
          v-bind="{ ...attrs, ...darkOrLightMode }"
          v-on="on"
          :hint="field.field_options.description"
          persistent-hint
          color="secondary-action"
          :rules="getFieldRules({ required: field.required })"
        >
          <template v-slot:append>
            <v-btn icon v-on="on">
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>

          <template v-slot:message="{ message }">
            <legend v-html="message" />
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="fieldValue"
        event-color="primary"
        color="primary-action"
        first-day-of-week="1"
        @input="dateMenu = false"
        :readonly="readonly"
        :locale="selectedLang"
      />
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import dateTimeMixin from '../../../mixins/dateTimeMixin';
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [dateTimeMixin, formsMixin],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      dateMenu: false,
      fieldValue: this.formModel[this.field.cid] ? this.formModel[this.field.cid] : '',
    };
  },
  computed: {
    ...mapState('language', ['selectedLang']),
  },
  watch: {
    formModel(newValue) {
      const value = newValue[this.field.cid] ? newValue[this.field.cid] : '';
      if (this.fieldValue != value) {
        this.fieldValue = value;
      }
    },
    fieldValue(newValue) {
      this.$emit('formUpdated', this.field.cid, newValue);
    },
  },
};
</script>
